import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import CartStep from '../CartStep';
import Order from '../order/Order';
import Seats from '../Seats';
import LoginContent from '../LoginContent';
import GroupedTickets from '../GroupedTickets';
import useLoadingCartStep from '../../hoc/useLoadingCartStep';
import groupedTickets from '../../utils/helpers';
import { selectCartSeats, selectCartTickets } from '../../selectors';
import { selectAuthUsername } from '../../../core/selectors/auth';
import { CART_STEP_1, CART_STEP_2 } from '../../constants/steps';

const CartStep1 = () => useLoadingCartStep(CartStep1Content);
const CartStep1Content = ({ currency }) => {
    const title = <FormattedMessage id="cart_you_have_to_login" />;
    const seats = useSelector(selectCartSeats);
    const tickets = groupedTickets(useSelector(selectCartTickets));
    const username = useSelector(selectAuthUsername);
    const navigate = useNavigate();

    useEffect(() => {
        if (username) {
            navigate(`/cart/checkout/${CART_STEP_2}`);
        } else {
            navigate(`/cart/checkout/${CART_STEP_1}`);
        }
    }, [username]);

    return (
        <CartStep title={title}>
            <div className={`cart__content cart__content--${CART_STEP_2}`}>
                <div className="row">
                    <div className="col-lg-6 col-12 mb-4">
                        <Order open={false}>
                            <GroupedTickets tickets={tickets} currency={currency} />
                        </Order>
                        <div className="mb-4"/>
                        <Seats userSeats={seats} open={false}/>
                    </div>
                    <div className="col-lg-6 col-12 mb-4">
                        <div className="bg-white p-3 rounded sticky-lg-top payment-methods-container">
                            <div className="d-grid gap-3">
                                <LoginContent/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CartStep>
    );
};

export default CartStep1;
